import { render } from "./nuevoPedidoADistribuidor.vue?vue&type=template&id=ce846692&scoped=true"
import script from "./nuevoPedidoADistribuidor.vue?vue&type=script&lang=js"
export * from "./nuevoPedidoADistribuidor.vue?vue&type=script&lang=js"

import "./nuevoPedidoADistribuidor.vue?vue&type=style&index=0&id=ce846692&scoped=true&lang=css"
import "./nuevoPedidoADistribuidor.vue?vue&type=style&index=1&id=ce846692&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce846692"]])

export default __exports__